module.exports = __webpack_public_path__ + "static/media/team-3.ce737683.svg";